module.exports = __webpack_public_path__ + "img/sp.e949573c.png";